<ng-container *ngIf="form" [formGroup]="form">
  <p-fieldset class="w-full"  [legend]="'protocol.default.title.protocol' | transloco">
        <div class="grid grid-cols-2 xl:grid-cols-4  gap-4 sm:gap-2 w-full" formGroupName="protocol" >
          <div class="flex flex-col justify-center align-items-center gap-1">
            <div class="flex flex-col align-items-center gap-1 mb-1 w-full">
              <label for="numero" class="font-semibold">{{'protocol.default.number' | transloco}}</label>
              <input id="numero" pInputText class="w-full" formControlName="number" placeholder="{{'protocol.default.number' | transloco}}"  >
            </div>
          </div>

          <div class="flex flex-col justify-center align-items-center gap-1">
            <div class="flex flex-col align-items-center gap-1 mb-1 w-full">
                <label for="date" class="font-semibold">{{'protocol.default.date' | transloco}}</label>
                <input id="date" type="date" pInputText class="w-full" formControlName="date">
            </div>
          </div>

          <div class="flex flex-col justify-center align-items-center gap-1">
            <div class="flex flex-col align-items-center gap-1 mb-1 w-full">
              <label for="time" class="font-semibold">{{'protocol.default.time' | transloco}}</label>
              <input type="time" id="time" pInputText class="w-full" formControlName="time" >
            </div>
          </div>

          <div class="flex flex-col  justify-center align-items-center gap-1">
            <div class="flex flex-col align-items-center gap-1 mb-1 w-full">
                <app-default-select [manualOptions]="protocolStatues()" formControlName="status"
                                    label="{{'protocol.default.status' | transloco}}"></app-default-select>
            </div>
          </div>
        </div>
  </p-fieldset>
</ng-container>
